var _style, _g, _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 103",
    style: {
      enableBackground: "new 0 0 103 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000157306500079149708240000002565315066063850660_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 6.2,
    y: 6.2,
    width: 90.6,
    height: 90.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011733006565101603870000014507654513930203531_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000011733006565101603870000014507654513930203531_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3,43.7c1.5,0,2.7-1.2,2.7-2.7s-1.2-2.7-2.7-2.7c-1.5,0-2.7,1.2-2.7,2.7S28.8,43.7,30.3,43.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9,54.3c1.5,0,2.7-1.2,2.7-2.7c0-1.5-1.2-2.7-2.7-2.7c-1.5,0-2.7,1.2-2.7,2.7C22.3,53.1,23.5,54.3,24.9,54.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3,24.2c-3.1-4-3.7-9.8-1.6-14.1l0-0.1c0.9-1.8-0.4-3.8-2.4-3.8H19.6c-0.9,0-1.8,0.5-2.3,1.3 c-0.5,0.8-0.5,1.8-0.1,2.6l0,0.1c2.1,4.3,1.5,10.1-1.6,14.1C8.2,34.1,5,46.1,6.6,58.1c3,21.1,21.7,38.7,44.9,38.7 c25.1,0,45.3-20.5,45.3-45.1C96.8,41.8,93.5,32.3,87.3,24.2z M23.4,11.5h56.2c-1,4.2-0.5,8.8,1.5,12.8c-0.1,0.3-0.2,0.6-0.3,0.9 c-0.1,1.1-2.2,2.7-5.3,2.7c-3,0-5.3-1.5-5.3-2.8c0-1.5-1.2-2.7-2.7-2.7s-2.7,1.2-2.7,2.7c0,1.3-2.3,2.8-5.3,2.8 c-3,0-5.3-1.5-5.3-2.8c0-1.5-1.2-2.7-2.7-2.7c-1.5,0-2.7,1.2-2.7,2.7c0,1.3-2.3,2.8-5.3,2.8c-3,0-5.3-1.5-5.3-2.8 c0-1.5-1.2-2.7-2.7-2.7c-1.5,0-2.7,1.2-2.7,2.7c0,1.3-2.3,2.8-5.3,2.8c-3,0-5.3-1.5-5.3-2.8c0-0.5-0.1-0.9-0.3-1.3 C23.9,20,24.4,15.6,23.4,11.5z M51.5,91.5c-20.2,0-36.9-15.3-39.6-34.1c-1.4-9.9,1-19.8,6.7-28.1c1.8,2.4,5.2,4,9.1,4 c3.2,0,6-1,8-2.7c1.9,1.7,4.8,2.7,8,2.7c3.2,0,6-1,8-2.7c1.9,1.7,4.8,2.7,8,2.7c3.2,0,6-1,8-2.7c1.9,1.7,4.8,2.7,8,2.7 c3.8,0,7.1-1.5,9-3.8c4.6,6.7,7,14.3,7,22.2C91.5,73.5,73.6,91.4,51.5,91.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4,62.3c3.2-2.4,5.3-6.3,5.3-10.6c0-1.5-1.2-2.7-2.7-2.7H67.4c-3.6,0-7.1,1.5-9.6,4.1l-0.6-1.2c-1.5-3-0.9-6.6,1.5-9 c0.8-0.8,1-1.9,0.6-2.9c-0.4-1-1.4-1.6-2.5-1.6h-5.3c-8.2,0-15.4,5.4-17.8,13.3c-6.3,3.3-10.6,8.7-10.8,9c-0.8,1-0.8,2.3,0,3.3 c0.3,0.3,4.5,5.7,10.8,9c2.4,7.9,9.6,13.3,17.8,13.3h5.3c1.1,0,2-0.6,2.5-1.6c0.4-1,0.2-2.1-0.6-2.9c-2.4-2.4-2.9-6-1.5-9 l0.6-1.2c2.5,2.6,5.9,4.1,9.6,4.1H78c1.5,0,2.7-1.2,2.7-2.7C80.7,68.6,78.6,64.7,75.4,62.3z M52,43.7c-0.9,2.2-1.1,4.6-0.7,7 c-2.4-1-5-1.7-7.8-1.7c-1,0-1.9,0.1-2.8,0.2C43.2,45.9,47,43.7,52,43.7z M40.7,75.3c0.9,0.1,1.8,0.2,2.8,0.2 c2.8,0,5.4-0.7,7.8-1.7c-0.4,2.3-0.2,4.8,0.7,7C47,80.9,43.2,78.7,40.7,75.3z M43.5,70.3c-5.6,0-11.2-3.9-15-8 c3.9-4.1,9.4-8,15-8c6.5,0,12.4,5.2,15,8C55.9,65,50.1,70.3,43.5,70.3z M67.4,70.3c-2.4,0-4.8-1.1-6.3-3c0.9-0.9,1.7-1.7,2.2-2.3 h4.1c3.5,0,6.4,2.2,7.5,5.3H67.4z M67.4,59.6h-4.1c-0.5-0.6-1.3-1.4-2.2-2.3c1.5-1.9,3.8-3.1,6.3-3.1h7.5 C73.8,57.4,70.9,59.6,67.4,59.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFish);
export default __webpack_public_path__ + "static/media/Fish.60dd3214629926ff354752bac94d3b6c.svg";
export { ForwardRef as ReactComponent };